import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { SharedModule } from '../shared/shared.module';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { AccountComponent } from './account/account.component';
import { GeneralInformationComponent } from './account/general-information/general-information.component';
import { PrimaryContactInformationComponent } from './account/primary-contact-information/primary-contact-information.component';
import { MfkInformationComponent } from './account/mfk-information/mfk-information.component';
import { SalesInformationComponent } from './account/sales-information/sales-information.component';
import { ProcessingInformationComponent } from './account/processing-information/processing-information.component';
import { MyMerchantAccountsComponent } from './my-merchant-accounts/my-merchant-accounts.component';
import { MerchantAccountsComponent } from './merchant-accounts/merchant-accounts.component';
import { CashnetAccountsComponent } from './cashnet-accounts/cashnet-accounts.component';
import { InvalidMerchantAccountsComponent } from './invalid-merchant-accounts/invalid-merchant-accounts.component';
import { UniversityPersonModule, UniversityPersonService } from '@uiowa/university-person';
import { UiowaMfkModule } from '@uiowa/uiowa-mfk';
import { DigitOnlyModule } from '@uiowa/digit-only';
import { MerchantAccountService, UniversityPersonSearchService } from '../shared';
import { MerchantAccountRoutingModule } from './merchant-account-routing.module';

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UniversityPersonModule,
        FormsModule,
        ReactiveFormsModule,
        MerchantAccountRoutingModule,
        UiowaMfkModule,
        DigitOnlyModule
    ],
    declarations: [
        AccountComponent,
        GeneralInformationComponent,
        PrimaryContactInformationComponent,
        MfkInformationComponent,
        SalesInformationComponent,
        ProcessingInformationComponent,
        MyMerchantAccountsComponent,
        MerchantAccountsComponent,
        CashnetAccountsComponent,
        InvalidMerchantAccountsComponent
    ],
    providers: [
        MerchantAccountService,
        {
            provide: UniversityPersonService,
            useFactory: (httpClient: HttpClient) => {
                return new UniversityPersonSearchService(httpClient);
            },
            deps: [HttpClient]
        }
    ],
    exports: []
})
export class MerchantAccountModule { }